import { http } from '../../plugins/http';
import { getData } from '../../utils/get';

export default {

    reset(username, password, password_confirmation, token) {
        return http.post(`/api/password/reset`, {
            username: username,
            password: password,
            password_confirmation: password_confirmation,
            token: token
        }).then(getData);
    }

};



// WEBPACK FOOTER //
// ./src/services/Auth/PasswordResetController.js